import { createApp } from 'vue'
import Pinball from './pages/Pinball.vue'
import './assets/styles/utilities.css';

createApp(Pinball).mount('#app')
